import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();

    if (user === null) {
        return (
            <div className="flex h-screen items-center justify-center bg-zinc-50">
                <div className="flex flex-col items-center gap-3">
                    <div className="h-6 w-6 animate-spin rounded-full border-2 border-zinc-300 border-t-[#FF3B30]" />
                    <span className="text-xs uppercase tracking-[0.2em] text-zinc-500">
                        A carregar
                    </span>
                </div>
            </div>
        );
    }

    if (!user) return <Navigate to="/login" replace />;
    if (user.role === "cliente") return <Navigate to="/minha-conta" replace />;

    return children;
}
